module.exports = __webpack_public_path__ + "static/img/1.b23aedd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/13/zh/1.png
// module id = NLNq
// module chunks = 0